import { encode, decode } from './hash-string';
import { AUTH_TOKEN, REFRESH_TOKEN } from '../constants/localStorageKey';

const IS_DEV = import.meta.env.DEV;

export const storeTokens = (accessToken: string, refreshToken: string): void => {
  if (IS_DEV) {
    localStorage.setItem(AUTH_TOKEN, JSON.stringify({ accessToken }));
    localStorage.setItem(REFRESH_TOKEN, JSON.stringify({ refreshToken }));
  } else {
    localStorage.setItem(AUTH_TOKEN, JSON.stringify({ accessToken: encode(accessToken) }));
    localStorage.setItem(REFRESH_TOKEN, JSON.stringify({ refreshToken: encode(refreshToken) }));
  }
};

export const getAccessToken = (): string | null => {
  const raw = localStorage.getItem(AUTH_TOKEN);
  if (!raw) return null;
  const parsed = JSON.parse(raw);
  if (IS_DEV) return parsed.accessToken ?? null;
  const decoded = decode(parsed.accessToken);
  return typeof decoded === 'string' ? decoded : null;
};

export const getRefreshToken = (): string | null => {
  const raw = localStorage.getItem(REFRESH_TOKEN);
  if (!raw) return null;
  const parsed = JSON.parse(raw);
  if (IS_DEV) return parsed.refreshToken ?? null;
  const decoded = decode(parsed.refreshToken);
  return typeof decoded === 'string' ? decoded : null;
};
